import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Pagination } from 'antd';
import { IAssignDevicesContext, AssignDevicesContext } from '../../devicesFormState/devicesFormContext';
import style from './AssignDevicesPagination.module.scss';

const AssignDevicesPagination: React.FC = () => {
	const { changeCurrentPage, restaurantDevices, currentPage, countOfItems } =
		useContext<IAssignDevicesContext>(AssignDevicesContext);

	const from = (currentPage - 1) * Number(countOfItems) + 1;
	const to = currentPage * Number(countOfItems);
	const total = restaurantDevices.count;

	return (
		<div className={style.container}>
			<Text
				className={style.counter}
				translationNameSpace="form"
				translationKey="paginationLabel"
				translationOptions={{
					from,
					to: to < total ? to : total,
					total,
				}}
				size="xs"
			/>
			<Pagination
				current={currentPage}
				pageSize={Number(countOfItems)}
				total={restaurantDevices.count}
				onChange={changeCurrentPage}
				showSizeChanger={false}
			/>
			<div className={style.plug}></div>
		</div>
	);
};

export default AssignDevicesPagination;
